/**
 * Checks if a process environment variable is present.
 * @param {string} variableName - The name of the environment variable.
 * @returns {boolean} - True if the environment variable is present, false otherwise.
 */
export function isEnvVariablePresent(variableName: string): boolean {
  if (typeof process === "undefined" || typeof process.env === "undefined") {
    console.warn("process.env is not available in this environment");
    return false;
  }
  return process.env[variableName] !== undefined;
}

export const getCategoryName = (breadCrumbs: any) => {
  return breadCrumbs?.[breadCrumbs?.length - 1]?.label?.toLowerCase() || "";
};
